import axios from 'axios';
import { Account, ChannelRegisterRequest } from '@/shared/model/scrap-agent.model';

const COMMON_API = '/api/social-channels';
const COMMON_SCRAP_API = '/api/scrap-agents';
const COMMON_USER_API = '/api/user-accounts';

const CLIENT_ID = '282196142246-bmgl02ms6oohg6r2rslsvuui721se15e.apps.googleusercontent.com';
const CLIENT_SECRET = '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';
const REDIRECT_URI = 'https://goover.ai/api/public/goAuth';

export default class ScrapAgentService {
  //channel api.........................................................................................................
  public addSocialChannel(data: ChannelRegisterRequest) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_API, data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllChannel(userKey: string, bpId?: string, page?: number, size?: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/social-channel', {
          userKey: userKey,
          bpId: bpId || null,
          page: 0,
          size: 100000,
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllChannelByChannel(userKey: string, sourceChannel: string[], page?: number, size?: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/social-channel/channel', {
          userKey,
          sourceChannel,
          bpId: null,
          page,
          size,
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public countAllChannel(userKey: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/social-channel/count-all-account-by-channel', {
          userKey,
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getListChannelConnectAccount(typeCategory?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get('/api/social-channel/get-list-channel-connect-account', {
          params: {
            typeCategory: typeCategory,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public deleteSocialChannel(id: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(COMMON_API + '/' + id)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateSocialChannel(id: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(COMMON_API + '/' + id)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  // scrap-agent-content api

  public addScrapAgent(data: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_SCRAP_API, data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateScrapAgent(data: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_SCRAP_API + '/update-datasource-scrape-agents', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateAccount(data: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_SCRAP_API + '/update-account-datasources', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public unlinkAccount(data: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_SCRAP_API + '/unlink-account', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public addScrapAgentUrl(data: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_SCRAP_API + '/url', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getUserScrapAgent(data: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('api/user-accounts/all-account-chanel', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public async getAppInfo(channelName: string): Promise<any> {
    return axios
      .post('api/app/get-app-info', { channelName })
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching app info:', error);
        return Promise.reject(error);
      });
  }

  public deleteScrapAgent(payload: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_SCRAP_API + '/remove-datasource-account', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  //user-account api

  public addUserAccount(data: Account) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_USER_API + '/create', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public reAuthorAccount(data: Account) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(COMMON_USER_API + '/re-authorize', data)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getUserAccount() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(COMMON_SCRAP_API + ' ')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public deleteUserAccount(id: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(COMMON_USER_API + '/delete-account/' + id)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateUserAccount(id: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(COMMON_SCRAP_API + '/' + id)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  //api connect channel.................................................................................................

  //connect google account

  authorize() {
    const url = `https://accounts.google.com/o/oauth2/auth?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=https://www.googleapis.com/auth/drive.readonly&access_type=offline&prompt=consent`;
    window.location.href = url;
  }

  async getToken(authCode) {
    try {
      const response = await axios.post('https://oauth2.googleapis.com/token', null, {
        params: {
          code: authCode,
          client_id: CLIENT_ID,
          client_secret: CLIENT_SECRET,
          redirect_uri: REDIRECT_URI,
          grant_type: 'authorization_code',
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      const { access_token, refresh_token } = response.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      return { access_token, refresh_token };
    } catch (error) {
      console.error('Lỗi khi lấy token:', error);
      return null;
    }
  }

  async getDriveFiles() {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      console.error('Chưa có access token');
      return;
    }

    try {
      const response = await axios.get('https://www.googleapis.com/drive/v3/files', {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      return response.data.files;
    } catch (error) {
      console.error('Lỗi khi lấy dữ liệu từ Google Drive:', error);
      return [];
    }
  }

  async refreshToken() {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
      console.error('Chưa có refresh token');
      return null;
    }

    try {
      const response = await axios.post('https://oauth2.googleapis.com/token', null, {
        params: {
          client_id: CLIENT_ID,
          client_secret: CLIENT_SECRET,
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });

      const { access_token } = response.data;
      localStorage.setItem('access_token', access_token);
      return access_token;
    } catch (error) {
      console.error('Lỗi khi làm mới token:', error);
      return null;
    }
  }

  async saveDefaultScrapAgentByType(userKey: string, requestBody: any) {
    try {
      const response = await axios.post(`/api/default-scrap-agent?userKey=${userKey}`, requestBody);

      console.log('Response:', response.data);
    } catch (error) {
      console.error('Error saving default scrap agent:', error);
    }
  }
}
